import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { OrganizationDetail, OrganizationStats, OrganizationDetailAndStats } from '../data/organization-detail';

@Component({
  selector: 'app-org-list',
  templateUrl: './org-list.component.html',
  styleUrls: ['./org-list.component.css']
})
export class OrgListComponent extends BaseComponent implements OnInit, OnChanges {

  @Input() orgs: OrganizationDetailAndStats[];
  @Input() showParent: boolean;
  @Input() noMatches: boolean;
  @Input() loading: boolean;
  @Input() showType: boolean;

  ngOnChanges() {
    this.orgs.map(org => {
      this.dataService.getOrganizationStats(org.ID).subscribe(stats => {
        if (stats) {
          org.Stats = stats;
        } else {
          this.handleSaveError();
        }
      });
    });
  }
}
